import {
  Navigate,
  useLoaderData,
  useNavigate,
  useSearchParams,
} from 'react-router-dom'
import type { ModalType } from '@/features/login'
import { defaultRouterPath, LOGO } from '@/constants/common.ts'
import { API_TOKEN_KEY } from '@/constants/storage'
import { checkToken } from '@/apis/user'
import LoginImg from '@/assets/login/loginV2.png'
import { LoginOrRegister } from '@/features/login/LoginOrRegister'
import { CreateWorkspace } from '@/features/login/CreateWorkspace'
import { Invite } from '@/features/login/Invite'

const ANONYMOUS_USER_ID = -1000

type Authenticated = boolean

export async function loader(): Promise<Authenticated> {
  const token = localStorage.getItem(API_TOKEN_KEY)
  if (!token) {
    return false
  }
  try {
    const user = await checkToken(token)
    return user.userId !== ANONYMOUS_USER_ID
  } catch (_) {
    return false
  }
}

function LoginPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const redirect = searchParams.get('redirect')

  const innerRedirect =
    !redirect || redirect === '/' ? defaultRouterPath : redirect

  const type = searchParams.get('type') as ModalType | null
  const channel = searchParams.get('channel')
  const link_id = searchParams.get('link_id')

  const authenticated = useLoaderData() as Authenticated

  if (authenticated && (!type || type === 'login')) {
    return <Navigate to={innerRedirect} />
  }

  if (!authenticated && type === 'login' && channel) {
    return <Navigate to='/login?type=register' />
  }

  return (
    <div
      className='relative w-100vw h-100vh flex'
      style={{
        background:
          'linear-gradient(348deg, rgba(170, 85, 255, 0.28) 5%, rgba(76, 105, 255, 0.2) 21%, rgba(104, 192, 255, 0.12) 54%, rgba(168, 252, 255, 0) 88%)',
      }}
    >
      <img className='absolute top-24px left-32px w-130px' src={LOGO} alt='' />
      <div className='max-ssm:w-0 max-md:w-480px md:w-33.33vw flex-center'>
        <img className='w-420px' src={LoginImg} alt='' />
      </div>
      <div className='max-md:flex-1 md:w-66.67vw flex-center min-w-480px bg-#fff'>
        {(!type || type === 'login') && <LoginOrRegister />}
        {type === 'invite' && <Invite link_id={link_id || ''} />}
        {type === 'workspace' && (
          <CreateWorkspace
            inModal={false}
            onSuccess={() => {
              const redirect = searchParams.get('redirect')
              const innerRedirect =
                !redirect || redirect === '/' ? defaultRouterPath : redirect
              navigate(innerRedirect)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default LoginPage
